
import { Tire, TireType } from "@/utils/carpass/tire";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			value: new Tire()
		};
	},
	props: {
		tire: {
			type: Object as ()=>Tire,
			required: true
		}
	},
	computed: {
		tireTypeItems():ISelectItem<TireType>[]{
			return getEnumKeys(TireType).map(t=>{
				return {
					text: this.$ct(`carpass-tire-type-select.${t}`),
					value: getEnumValueFromKey(TireType, t)
				} as ISelectItem<TireType>;
			});
		},
	},
	watch: {
		tire: {
			immediate: true,
			handler(){
				this.value = new Tire(this.tire.getJSON());
			}
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", this.value);
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.cars"
	}
});
